<script lang="jsx">
  export default {
    name: 'MenuItem',
    functional: true,
    mobile: localFun.get('mobile'),
    props: {
      icon: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      },
      highlight: {
        type: String,
        default: ''
      }
    },
    render(h, context) {
      const { icon, title, highlight } = context.props;
      const vnodes = [];

      if (icon) {
        if (icon.includes('el-icon')) {
          vnodes.push(<i class={[icon, 'sub-el-icon']} />);
        } else {
          vnodes.push(<svg-icon icon-class={icon} class="icon-style" />);
        }
      }

      if (title) {
        if (highlight && title) {
          const texts = title.split(highlight);
          texts.forEach((text, index) => {
            vnodes.push(<span>{text}</span>);
            if (index !== texts.length - 1) {
              vnodes.push(<span class="text-highlight">{highlight}</span>);
            }
          });
        } else {
          vnodes.push(<span slot="title">{title}</span>);
        }
      }
      return vnodes;
    }
  };
</script>

<style scoped>
  .sub-el-icon {
    color: currentColor;
    width: 20px;
    height: 20px;
  }
  .icon-style {
    width: 20px !important;
    height: 20px !important;
  }
  .text-highlight {
    color: red;
    font-weight: bold;
  }
</style>